/* eslint-disable no-unused-vars */

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  HomeIcon,
  DocumentTextIcon,
  BeakerIcon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
  XMarkIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

const navigationItems = [
  {
    name: "Home",
    icon: HomeIcon,
    path: "/dashboard",
  },
  {
    name: "Notes",
    icon: DocumentTextIcon,
    path: "/notes",
  },
  {
    name: "Test",
    icon: BeakerIcon,
    path: "/test",
  },
  {
    name: "Profile",
    icon: UserCircleIcon,
    path: "/profile",
  },
];

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const handleLogout = () => {
    try {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user");
      sessionStorage.clear();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Error during logout:", error);
      navigate("/login", { replace: true });
    }
  };

  return (
    <div
      className={`fixed top-0 left-0 h-full bg-[#111111] border-r border-gray-800/40 transition-all duration-500 ease-in-out z-40
        ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
        lg:translate-x-0 lg:w-64`}
    >
      <div className="p-4 bg-gradient-to-r from-[#111111] to-[#111111]/90">
        <div className="flex items-center">
          <div className="flex items-center bg-[#111111] px-3 py-2 rounded-lg">
            <img src={logo} alt="Notui Logo" className="h-8 w-auto mr-2" />
            <h1 className="text-2xl font-semibold tracking-wide text-white">
              Notui
            </h1>
          </div>
        </div>
      </div>

      <nav className="mt-8 px-3">
        {navigationItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`flex items-center px-4 py-3 rounded-lg mb-1 text-base transition-all duration-200 group ${
              pathname.startsWith(item.path)
                ? "bg-blue-500/10 text-blue-500"
                : "text-gray-400 hover:text-white hover:bg-dark-hover/50"
            }`}
          >
            <item.icon
              className={`w-6 h-6 min-w-[24px] transition-transform duration-200 group-hover:scale-110 ${
                pathname.startsWith(item.path) ? "text-blue-500" : ""
              }`}
            />
            <span className="ml-3">{item.name}</span>
          </Link>
        ))}
      </nav>

      <div className="absolute bottom-8 w-full px-4">
        <button
          onClick={handleLogout}
          className="flex items-center px-4 py-2 text-gray-400 hover:text-white w-full transition-all duration-200 rounded-lg hover:bg-dark-hover/50 group"
        >
          <ArrowRightOnRectangleIcon className="w-6 h-6 min-w-[24px] transition-transform duration-200 group-hover:-translate-x-1" />
          <span className="ml-3">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
